import * as _ from "lodash";
import {DefaultEdgeModel} from "@/shared/models/defaultEdge";
import ReminderModel from "@/shared/models/reminder";
import {EntityType} from "@/shared/models/entityType";
import GroupModel from "@/shared/models/group";
import PersonModel from "@/shared/models/person";
import {Model} from "vue-property-decorator";
import NoteModel from "@/shared/models/note";
import {IRootModel} from "@/shared/models/abstract/IRootModel";


/**
 * Handles all related to data entities attached to nodes and edges.
 */
export default class ModelFactory {
    nodeBaseClass: any;
    edgeBaseClass: any;

    constructor(nodeBaseClass, edgeBaseClass) {
        this.nodeBaseClass = nodeBaseClass;
        this.edgeBaseClass = edgeBaseClass;
    }

    /**
     * Instantiates a new model of the specified type.
     * @param type {EntityType|EdgeType} The type to instantiate.
     * @param params
     * @returns {ReminderModel|GroupModel|PersonModel|*}
     */
    static createNew(type: string | EntityType, ...params) {
        let model;
        switch (type) {
            case EntityType.Reminder:
                model = new ReminderModel();
                break;
            case EntityType.Group:
                model = new GroupModel();
                break;
            case EntityType.Person:
                model = new PersonModel();
                break;
            case EntityType.Note:
                model = new NoteModel();
                break;
            case EntityType.DefaultEdge:
                // if (params.length !== 2) {
                //     throw new Error("Expected two extra parameters to create a DefaultEdgeModel");
                // }
                // model = new DefaultEdgeModel(params[0], params[1]);
                model = new DefaultEdgeModel(null, null);
                break;

            default:
                throw new Error(`Model creation for type '${type}' is not mapped.`);
        }
        return model;
    }

    /**
     * Return a model from the plain object.
     * @param blob {Object} The serialized model.
     * @returns {IRootModel}
     */
    public static fromJson(blob): IRootModel {

        if (_.isNil(blob)) {
            throw new Error("Cannot convert nil to a model.");
        }
        if (!_.isPlainObject(blob)) {
            throw new Error("Expected plain object to deserialize.");
        }
        if (blob.entityType) {
            let model = ModelFactory.createNew(blob.entityType);
            model = _.assign(model, blob);

            return model;
        } else {
            throw new Error("Missing entityType to deserialize model.")
        }
    }

    /**
     * Alias for the {@link fromJson} method.
     * @param json {Object} The serialized model.
     * @returns {IRootModel}
     */
    static parse(json) {
        return ModelFactory.fromJson(json);
    }

    /**
     * Serializes the given model.
     * @param model {RootModel} The model.
     * @returns {*}
     */
    toJson(model) {
        if (_.isNil(model)) {
            throw new Error("Cannot serialize nil.");
        }
        return model.toJson();
    }
}
